import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const harbor = defineConnector({
  identifier: "harbor",
  name: "Harbor",
  tagLine: "Open-source container registry",
  logo,
  protocol: "http",
  tags: ["engineering"],
  auth: (app) =>
    basicAuth({
      username: app.config.username,
      password: app.secret.secret,
    }),
  steps: [
    {
      title: "Create a Harbor robot account or API user",
      items: [
        {
          kind: "markdown",
          content:
            "Create a Harbor robot account or user account with the project permissions you need, then copy the generated secret.",
        },
      ],
    },
    {
      title: "Enter your Harbor details",
      items: [
        {
          kind: "url",
          label: "Harbor base URL",
          required: true,
          placeholder: "https://harbor.example.com",
          target: { kind: "configuration", field: "instanceUrl" },
        },
        {
          kind: "input",
          label: "Username or robot account",
          required: true,
          target: { kind: "configuration", field: "username" },
        },
        {
          kind: "input",
          label: "Secret",
          required: true,
          target: { kind: "secrets", field: "secret" },
        },
      ],
    },
  ],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) =>
      `${instanceUrl}/api/v2.0/projects?page=1&page_size=1`,
  },
});
